import React, { Fragment } from 'react';
import styled from 'styled-components';
import { QuestionAnswerDto } from 'ts-types/api.types';
import { MessageSourceProps, withMessages } from 'react-message-source';
import { AuthConsumerRenderProps, withAuthContext } from 'auth/AuthContext';

const ResultsPane = styled.div`
  flex: 0 0 auto;
  margin-right: 15px;
  min-width: 15rem;
  max-width: 36rem;

  .results-header {
    font-weight: bold;
    font-size: 1.1rem;
    border-bottom: 1px solid #e5e5e5;
    margin-bottom: 0.5rem;
  }

  .results-container {
    display: grid;
    grid-template-columns: minmax(min-content, 1fr) minmax(3.5rem, min-content);
    row-gap: 0.35rem;
    column-gap: 1.2rem;

    .result-question {
      color: #575757;

      .result-remarks {
        color: #8d8d8d;
        margin-left: 1em;
        font-style: italic;
        word-break: break-all;
      }
    }

    .result-answer.no-result {
      color: #a5a5a5;
    }
  }

`;

export interface QuestionSetViewProps extends MessageSourceProps, AuthConsumerRenderProps {
  questionSetName: string,
  questionAnswerPairs: Array<QuestionAnswerDto>
}


const QuestionSetView = (props: QuestionSetViewProps) => {

  const {
    questionSetName,
    questionAnswerPairs,
    language,
    getMessage
  } = props;

  return (
      <ResultsPane>
        <div className="results-header">{questionSetName}</div>
        <div className="results-container">
          {
            questionAnswerPairs.map(questionAnswerPair => {

              let answerText = questionAnswerPair.selectedAnswers.join(", ");
              let resultClass = "";
              if (!answerText || answerText === "") {
                return null;
              }

              if (answerText === 'true') {
                answerText = getMessage("anamnesis.answer.yes")
              } else if (answerText === 'false') {
                answerText = getMessage("anamnesis.answer.no")
              }

              let remarksText = questionAnswerPair.remarks;

              const nameMap: { [lang: string]: string } = {
                "de": questionAnswerPair.questionText,
                "en": questionAnswerPair.questionTextEn || questionAnswerPair.questionText,
                "fr": questionAnswerPair.questionTextFr || questionAnswerPair.questionText,
                "it": questionAnswerPair.questionTextIt || questionAnswerPair.questionText
              };

              return (
                  <Fragment key={`answer-row-${questionAnswerPair.questionId}`}>
                    <div className="result-question">
                      {nameMap[language]}
                      {
                        remarksText && remarksText.length &&
                          <div className="result-remarks">
                            {remarksText}
                          </div>
                      }
                    </div>
                    <div className={`result-answer ${resultClass}`}>
                      {answerText}
                    </div>
                  </Fragment>
              );
            }).filter(Boolean)
          }
        </div>
      </ResultsPane>
  );
};

export default withMessages(withAuthContext(QuestionSetView));
